import { Component, Input, ElementRef, OnChanges, OnInit, forwardRef, SimpleChanges, AfterViewInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, Validator, ControlValueAccessor } from '@angular/forms';
import { UploadFile } from 'ng-zorro-antd';
import { UploadPhotoHelper } from '../../../services/helper/upload-photo.helper';


@Component({
  selector: 'zx-photo-upload',
  templateUrl: './photo-upload.component.html',
  styleUrls: ['./photo-upload.component.css'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => PhotoUploadComponent), multi: true },
  ],
})
export class PhotoUploadComponent implements ControlValueAccessor {

  private onChangeCallback: Function = () => { };
  private onTouchedCallback: Function = () => { };

  private _value: any[] = [];
  private _previewStyle: any;
  private _uploadTextStyle: any;
  private _singleMode: boolean = false;
  private _limit: number = 10;
  fileList: any[];
  previewVisible: boolean = false;
  previewImage: string;

  constructor(
    public uploadPhotoHelper: UploadPhotoHelper,
  ) { }

  ngOnInit() { }

  @Input("zxSize") size: number = 1024;
  @Input("zxWidth") width: number = 96;
  @Input("zxHeight") height: number = 96;
  @Input("zxFileType") fileType: string;
  @Input("zxDisabled") disabled: boolean;
  @Input("zxTransparentBackground") transparentBackground: boolean = true;
  @Input("zxScaledImageSize") scaledImageSize: boolean = false;

  @Input("zxSingleMode") set singleMode(v: boolean) {
    this._singleMode = v;
  }
  get singleMode(): boolean {
    return this._singleMode || this._limit <= 1;
  }
  @Input("zxLimit") set limit(v: number) {
    this._limit = v;
  }
  get limit(): number {
    return this._singleMode ? 1 : this._limit;
  }


  get value(): string | string[] {
    if (this.singleMode) return (this._value.length > 0 ? this._value[0] : null);
    return this._value;
  }

  set value(md5: string | string[]) {
    this._value = md5 == null ? [] : (Array.isArray(md5)?md5:[md5]);
    this.valueToFileList();
    this.onChangeCallback(this._value);
  }

  get uploaderStyle() {
    return this.singleMode ? { display: 'inline-block', width: this.width + 'px', height: this.height + 'px' } : {};
  }
  @Input() set uploadTextStyle(v: any) {
    this._uploadTextStyle = v;
  }
  get uploadTextStyle() {
    const style = this._uploadTextStyle || {};
    if (style.fontSize == null) style.fontSize = '32px';
    if (style.color == null) style.color = '#999';
    return style;
  }
  @Input() set previewStyle(v: any) {
    if (v.width == null) v.width = "100%";
    this._previewStyle = v;
  }
  get previewStyle() {
    return this._previewStyle || { 'width': '100%' };
  }

  writeValue(value: any) {
    // console.log("PhotoUploadComponent -> writeValue() -> ", value);
    this.value = value;
  }

  registerOnChange(fn: Function): void {
    this.onChangeCallback = fn;
  }
  registerOnTouched(fn: Function): void {
    this.onTouchedCallback = fn;
  }

  private valueToFileList() {
    if(this.fileList != null && this.fileList.length > 0) this.fileList.splice(0, this.fileList.length);
    if(this._value == null || this._value.length == 0) return;

    if(this.fileList == null) this.fileList = [];
    let uid = -1;
    let url;
    this._value.forEach(item => {
      url = this.uploadPhotoHelper.resolvePhotoUrl(item);
      this.fileList.push({
        uid: uid,
        md5: item,
        name: item,
        status: 'done',
        url: url
      });
      uid--;
    });
  }
  private fileListToValue() {
    if(this.fileList == null) this.fileList = [];

    if (this.singleMode) {
      const md5 = this.fileList.map(file => file.md5).shift();
      if (this._value.length == 0 || this._value[0] !== md5) {
        this._value[0] = md5;
        this.onChangeCallback(this._value);
      }
    } else {
      this._value.splice(0, this._value.length);
      this._value.push(...this.fileList.map(file => file.md5));
      this.onChangeCallback(this._value);
    }
  }

  handlePreview = (file: UploadFile) => {
    this.previewImage = file.url || file.thumbUrl;
    this.previewVisible = true;
  }

  handleUploadChange = (event) => {
    let files = event.fileList;
    if (files.length == 0) files = [event.file];

    files.forEach(file => {
      if (file && file.status == "done") {
        const result = this.uploadPhotoHelper.parseUploadFile(file);
        file.md5 = result.md5;
        this.fileListToValue();
      } else if (file.status == "removed") {
        file.md5 = null;
        this.fileListToValue();
      }
    });
  }
}